import { IState } from '../../store';

export const selectAsideNavigationActive = (state: IState): boolean => {
  return state.aside.isNavigationActive;
};
